import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "../../types/commonElements";
import {
  modeOfPaymentOptions,
  paymentTypeOptions,
} from "../../config/constants/options";
import { FormData, ProcedureState } from "../../types/procedureType";

const initialState: ProcedureState = {
  formData: {
    procedureName: "",
    noOfSession: 1,
    totalAmount: "",
    amount: "",
    modeOfPayment: "",
    paymentReferenceNo: "",
    paymentType: "",
    focReason: "",
    paymentStatus: "",
    procedureStatus: "",
    isGstCollected: false,
    customerId: "",
  },
  errors: {},
  selectOptions: {
    paymentType: [paymentTypeOptions[0]],
    modeOfPayment: modeOfPaymentOptions,
    procedureName: [],
    paymentStatus: [],
    procedureStatus: [],
  },
  sessionRows: [],
};

const procedureSlice = createSlice({
  name: "procedure",
  initialState,
  reducers: {
    setFormData: (state, action: PayloadAction<FormData>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = action.payload;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    setSessionRows: (state, action: PayloadAction<any[]>) => {
      state.sessionRows = action.payload;
    },
    clearErrors: (state) => {
      state.errors = {};
    },
    clearForm: (state) => {
      state.formData = initialState.formData;
      state.errors = {};
      state.sessionRows = [];
    },
  },
});

export const {
  setFormData,
  setErrors,
  clearErrors,
  clearForm,
  setSelectOptions,
  setSessionRows,
} = procedureSlice.actions;

export default procedureSlice.reducer;
